export const ItemTypes = {
  CART_ITEM: 'cartItem',
  CART_SECTION: 'cartSection',

  DASHBOARD_GRID_WIDGET: 'dashboardGridWidget'
}
